fragment ReplyTaskThreadFragment on ReplyTaskThread {

    id

    task_id
    email_scanner_id

    emailScanner {
        ...ReplyTaskEmailScannerFragment
    }

}